/**
 * ITU-T E.212 Mobile Country Code (MCC) → ISO 3166-1 alpha-2 mapping.
 *
 * Source: ITU-T E.212 (11/2019) + Wikipedia "Mobile country code" article.
 * Used by detect_country_entry intelligence composite and mango.talk country-watch cron.
 */
export const MCC_TO_ISO: Record<number, string> = {
  // Europe
  202: "GR", // Greece
  204: "NL", // Netherlands
  206: "BE", // Belgium
  208: "FR", // France
  212: "MC", // Monaco
  213: "AD", // Andorra
  214: "ES", // Spain
  216: "HU", // Hungary
  218: "BA", // Bosnia and Herzegovina
  219: "HR", // Croatia
  220: "RS", // Serbia
  221: "XK", // Kosovo
  222: "IT", // Italy
  225: "VA", // Vatican City
  226: "RO", // Romania
  228: "CH", // Switzerland
  230: "CZ", // Czech Republic
  231: "SK", // Slovakia
  232: "AT", // Austria
  234: "GB", // United Kingdom
  235: "GB", // United Kingdom
  238: "DK", // Denmark
  240: "SE", // Sweden
  242: "NO", // Norway
  244: "FI", // Finland
  246: "LT", // Lithuania
  247: "LV", // Latvia
  248: "EE", // Estonia
  250: "RU", // Russia
  255: "UA", // Ukraine
  257: "BY", // Belarus
  259: "MD", // Moldova
  260: "PL", // Poland
  262: "DE", // Germany
  266: "GI", // Gibraltar
  268: "PT", // Portugal
  270: "LU", // Luxembourg
  272: "IE", // Ireland
  274: "IS", // Iceland
  276: "AL", // Albania
  278: "MT", // Malta
  280: "CY", // Cyprus
  282: "GE", // Georgia
  283: "AM", // Armenia
  284: "BG", // Bulgaria
  286: "TR", // Turkey
  288: "FO", // Faroe Islands
  289: "GE", // Abkhazia (Georgia)
  290: "GL", // Greenland
  292: "SM", // San Marino
  293: "SI", // Slovenia
  294: "MK", // North Macedonia
  295: "LI", // Liechtenstein
  297: "ME", // Montenegro

  // Commonwealth of Independent States / Former USSR
  401: "KZ", // Kazakhstan
  402: "BT", // Bhutan
  404: "IN", // India
  405: "IN", // India
  406: "IN", // India
  410: "PK", // Pakistan
  412: "AF", // Afghanistan
  413: "LK", // Sri Lanka
  414: "MM", // Myanmar
  415: "LB", // Lebanon
  416: "JO", // Jordan
  417: "SY", // Syria
  418: "IQ", // Iraq
  419: "KW", // Kuwait
  420: "SA", // Saudi Arabia
  421: "YE", // Yemen
  422: "OM", // Oman
  424: "AE", // United Arab Emirates
  425: "IL", // Israel
  426: "BH", // Bahrain
  427: "QA", // Qatar
  428: "MN", // Mongolia
  429: "NP", // Nepal
  430: "AE", // United Arab Emirates
  431: "AE", // United Arab Emirates
  432: "IR", // Iran
  434: "UZ", // Uzbekistan
  436: "TJ", // Tajikistan
  437: "KG", // Kyrgyzstan
  438: "TM", // Turkmenistan
  440: "JP", // Japan
  441: "JP", // Japan
  450: "KR", // South Korea
  452: "VN", // Vietnam
  454: "HK", // Hong Kong
  455: "MO", // Macau
  456: "KH", // Cambodia
  457: "LA", // Laos
  460: "CN", // China
  461: "CN", // China
  466: "TW", // Taiwan
  467: "KP", // North Korea
  470: "BD", // Bangladesh
  472: "MV", // Maldives
  502: "MY", // Malaysia
  505: "AU", // Australia
  510: "ID", // Indonesia
  514: "TL", // East Timor
  515: "PH", // Philippines
  520: "TH", // Thailand
  525: "SG", // Singapore
  528: "BN", // Brunei
  530: "NZ", // New Zealand
  536: "NR", // Nauru
  537: "PG", // Papua New Guinea
  539: "TO", // Tonga
  540: "SB", // Solomon Islands
  541: "VU", // Vanuatu
  542: "FJ", // Fiji
  544: "AS", // American Samoa
  545: "KI", // Kiribati
  546: "NC", // New Caledonia
  547: "PF", // French Polynesia
  548: "CK", // Cook Islands
  549: "WS", // Samoa
  550: "FM", // Micronesia
  551: "MH", // Marshall Islands
  552: "PW", // Palau
  553: "TV", // Tuvalu
  555: "NU", // Niue

  // Africa (ITU-T E.212)
  602: "EG", // Egypt
  603: "DZ", // Algeria
  604: "MA", // Morocco
  605: "TN", // Tunisia
  606: "LY", // Libya
  607: "GM", // Gambia
  608: "SN", // Senegal
  609: "MR", // Mauritania
  610: "ML", // Mali
  611: "GN", // Guinea
  612: "CI", // Côte d'Ivoire
  613: "BF", // Burkina Faso
  614: "NE", // Niger
  615: "TG", // Togo
  616: "BJ", // Benin
  617: "MU", // Mauritius
  618: "LR", // Liberia
  619: "SL", // Sierra Leone
  620: "GH", // Ghana
  621: "NG", // Nigeria
  622: "TD", // Chad
  623: "CF", // Central African Republic
  624: "CM", // Cameroon
  625: "CV", // Cape Verde
  626: "ST", // São Tomé and Príncipe
  627: "GQ", // Equatorial Guinea
  628: "GA", // Gabon
  629: "CG", // Republic of the Congo
  630: "CD", // Democratic Republic of the Congo
  631: "AO", // Angola
  632: "GW", // Guinea-Bissau
  633: "SC", // Seychelles
  634: "SD", // Sudan
  635: "RW", // Rwanda
  636: "ET", // Ethiopia
  637: "SO", // Somalia
  638: "DJ", // Djibouti
  639: "KE", // Kenya
  640: "TZ", // Tanzania
  641: "UG", // Uganda
  642: "BI", // Burundi
  643: "MZ", // Mozambique
  645: "ZM", // Zambia
  646: "MG", // Madagascar
  647: "RE", // Réunion / French Indian Ocean
  648: "ZW", // Zimbabwe
  649: "NA", // Namibia
  650: "MW", // Malawi
  651: "LS", // Lesotho
  652: "BW", // Botswana
  653: "SZ", // Eswatini
  654: "KM", // Comoros
  655: "ZA", // South Africa
  657: "ER", // Eritrea
  658: "SH", // Saint Helena
  659: "SS", // South Sudan
  702: "BZ", // Belize
  704: "GT", // Guatemala
  706: "SV", // El Salvador
  708: "HN", // Honduras
  710: "NI", // Nicaragua
  712: "CR", // Costa Rica
  714: "PA", // Panama
  716: "PE", // Peru
  722: "AR", // Argentina
  724: "BR", // Brazil
  730: "CL", // Chile
  732: "CO", // Colombia
  734: "VE", // Venezuela
  736: "BO", // Bolivia
  738: "GY", // Guyana
  740: "EC", // Ecuador
  742: "GF", // French Guiana
  744: "PY", // Paraguay
  746: "SR", // Suriname
  748: "UY", // Uruguay
  750: "FK", // Falkland Islands

  // North America, Caribbean
  302: "CA", // Canada
  308: "PM", // Saint Pierre and Miquelon
  310: "US", // United States
  311: "US", // United States
  312: "US", // United States
  313: "US", // United States
  314: "US", // United States
  315: "US", // United States
  316: "US", // United States
  330: "PR", // Puerto Rico
  332: "VI", // U.S. Virgin Islands
  334: "MX", // Mexico
  338: "JM", // Jamaica
  340: "GP", // Guadeloupe
  342: "BB", // Barbados
  344: "AG", // Antigua and Barbuda
  346: "KY", // Cayman Islands
  348: "VG", // British Virgin Islands
  350: "BM", // Bermuda
  352: "GD", // Grenada
  354: "MS", // Montserrat
  356: "KN", // Saint Kitts and Nevis
  358: "LC", // Saint Lucia
  360: "VC", // Saint Vincent and the Grenadines
  362: "CW", // Curaçao / Netherlands Antilles
  363: "AW", // Aruba
  364: "BS", // Bahamas
  365: "AI", // Anguilla
  366: "DM", // Dominica
  368: "CU", // Cuba
  370: "DO", // Dominican Republic
  372: "HT", // Haiti
  374: "TT", // Trinidad and Tobago
  376: "TC", // Turks and Caicos Islands

  // Special / Test MCCs
  999: "XX", // Test network
  901: "XX", // International / satellite
};

/**
 * Resolve an MCC (Mobile Country Code, ITU-T E.212) to ISO 3166-1 alpha-2.
 * Returns null for unknown MCCs.
 */
export function mccToIso(mcc: number | string | null | undefined): string | null {
  if (mcc == null) return null;
  let n: number;
  if (typeof mcc === "string") {
    const trimmed = mcc.trim();
    if (trimmed === "" || !/^\d+$/.test(trimmed)) return null;
    n = parseInt(trimmed, 10);
  } else {
    n = mcc;
  }
  if (!Number.isFinite(n)) return null;
  return MCC_TO_ISO[n] ?? null;
}

/**
 * Reverse: get all MCCs for a given ISO 3166-1 alpha-2 country code.
 */
export function isoToMccs(iso: string): number[] {
  const upper = iso.toUpperCase();
  return Object.entries(MCC_TO_ISO)
    .filter(([, v]) => v === upper)
    .map(([k]) => Number(k));
}
